import type { RootState } from "~/redux/store";

export const selectSavedAffiliate = (state: RootState) => state.affiliate.savedAffiliate;
export const selectPreviousSavedAffiliate = (state: RootState) => state.affiliate.previousSavedAffiliate;
export const selectVisitedAffiliate = (state: RootState) => state.affiliate.visitedAffiliate;
export const selectSavedSubsidiaryId = (state: RootState) => state.affiliate.savedSubsidiaryId;
export const selectPreviousSavedSubsidiaryId = (state: RootState) => state.affiliate.previousSavedSubsidiaryId;
